'use client'

import { InView } from 'react-intersection-observer'

import { useAbTest, useTrackAbTestCallback } from '@marketplace-web/shared/ab-tests'

type Props = {
  children: React.ReactNode
}

const FeedContentWrapper = ({ children }: Props) => {
  const reversedMixedItemsBlocks = useAbTest('item_page_reversed_mixed_items_blocks')
  const trackAbTest = useTrackAbTestCallback()

  const handleCrossSellingChannelsView = (inView: boolean) =>
    inView && trackAbTest(reversedMixedItemsBlocks)

  return (
    <InView
      as="div"
      className="u-ui-margin-top-medium"
      onChange={handleCrossSellingChannelsView}
      triggerOnce
    >
      {children}
    </InView>
  )
}

export default FeedContentWrapper
